import "./DockerFeed";
import "./GitHubFeed";
import "./MavenFeed";
import "./NuGetFeed";
import "./HelmFeed";
import "./AwsElasticContainerRegistry";
import feedTypeRegistry from "./feedTypeRegistry";
export default feedTypeRegistry;
